// How one job stays current wherever it shows (its page, the studio's detail modal): stream events
// patch and refetch it (F3); while it can still change it is also read on window focus, and every
// 15 s while the stream is not live; and it is read again shortly before its output URLs expire.
import { useGetJob } from "../../../api/generated/endpoints/generation/generation";
import { urlsDue } from "../../../api/signed-urls";
import { useStreamStatus } from "../../../platform/stream-status";
import { canChange, jobPageInterval } from "../../../platform/jobs/refetch";

export function useJob(teamId: string, jobId: string) {
  const stream = useStreamStatus();
  return useGetJob(teamId, jobId, {
    query: {
      refetchInterval: (query) => jobPageInterval(query.state.data, stream),
      refetchOnWindowFocus: (query) => {
        const data = query.state.data;
        return canChange(data?.status) || urlsDue(data?.urls_expire_at) ? "always" : false;
      },
    },
  });
}
